export const getCompaniesList = (state) => state.companies.companies;
export const getCurrentCompany = (state) =>
  state.companies.companies.find((company) => company.checked) ||
  state.companies.companies[0];
export const getCompaniesStatus = (state) => state.companies.status;
